class EggPunGenerator extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.cards = this.querySelectorAll('.pun-card--wrapper');
    this.revealButton = this.querySelector('.reveal-button'); 
    this.pickAgainButton = this.querySelector('.pick-again-button');
    const _this = this;

    this.cards.forEach((card, idx) => {
      card.addEventListener('click', () => {
        const state = _this.getState();
        console.log(state);
        switch(state) {
          case 'questionsMode':
            _this.activeCard = _this.cards[idx];
            _this.activeCard.classList.add("active");
            _this.activeCard.querySelector(".visually-hidden").textContent = 'Selected card:';
            _this.cards.forEach((card, i) => {
              if (i == idx) return;
              card.querySelector("button").setAttribute("tabindex", "-1"); 
              card.setAttribute("inert", "true");
            });
            if (card.classList.contains("flipped")) {
              _this.setState('answerMode');
              return;
            }
            _this.setState('revealMode');
            _this.revealButton.focus();
            break;

          case 'revealMode':
            _this.setState('answerMode');
            _this.activeCard.classList.add('flipped'); 
            _this.activeCard.querySelector(".visually-hidden").textContent = '';
            _this.activeCard.querySelector("button").focus();
            break;

          case 'answerMode':
            _this.setState('questionsMode');
            _this.activeCard.classList.remove("flipped");
            _this.activeCard.classList.remove('active');
            _this.cards.forEach(card => {
              card.querySelector("button").setAttribute("tabindex", "0");
              card.removeAttribute("inert");
            });
            _this.activeCard.querySelector("button").focus();
            _this.activeCard.querySelector(".visually-hidden").textContent = 'Select card:';
            break;
        }
      })
    });

    this.revealButton.addEventListener('click', () => {
      _this.setState('answerMode');
      _this.activeCard.classList.add('flipped'); 
      _this.activeCard.querySelector(".visually-hidden").textContent = '';
      _this.activeCard.querySelector("button").focus();
    });

    this.pickAgainButton.addEventListener('click', () => {
      _this.setState('questionsMode');
      _this.activeCard.classList.remove("flipped");
      _this.activeCard.classList.remove('active');
      _this.cards.forEach(card => {
        card.querySelector("button").setAttribute("tabindex", "0");
        card.removeAttribute("inert");
      });
      _this.activeCard.querySelector("button").focus();
      _this.activeCard.querySelector(".visually-hidden").textContent = 'Select card:';
    });
  }

  getState() {
    return this.dataset.state;
  }

  setState(state) {
    this.setAttribute('data-state', state);
  }
}

customElements.define('egg-pun-generator', EggPunGenerator);
